import React from 'react';
import {formatCurrency} from "../../utils/monetary";
import {CSVLink} from "react-csv";
import {Button} from "antd";
import dayjs from "dayjs";

const BookingExport = ({bookings}) => {
  // Définition des en-têtes pour le CSV
  const csvHeaders = [
    { label: "Période réservée", key: "period" },
    { label: "Locataire", key: "tenant" },
    { label: "Immeuble", key: "building" },
    { label: "Montant location", key: "price" },
    { label: "Acompte locataire", key: "deposit" },
  ];

  // Trier les données par date de début (start_at) ascendante
  const sortedBookings = [...bookings].sort((a, b) => {
    const dateA = dayjs(a.start_at, "DD/MM/YYYY");
    const dateB = dayjs(b.start_at, "DD/MM/YYYY");
    return dateA.unix() - dateB.unix(); // Tri ascendant
  });

  const csvData = sortedBookings.map(booking => ({
    period: `Du ${booking.start_at} au ${booking.end_at}`,
    tenant: `${booking.tenant?.personne?.nom} ${booking.tenant?.personne?.prenom}`,
    building: booking.building?.nom || "",
    price: formatCurrency(booking.price),
    deposit: formatCurrency(booking.deposit_tenant),
  }));

  return (
    <Button>
      <CSVLink
        filename={"export_reservations.csv"}
        headers={csvHeaders}
        data={csvData}
        separator={";"}
      >
        Exporter liste
      </CSVLink>
    </Button>
  );
};

export default BookingExport;